import { InfoField } from "../InfoField";

const fieldValue = (value?: string | number) =>
  value === undefined || value === "" ? "-" : String(value);

export const CatalogDetailsCard = ({
  title,
  description,
  fields,
}: {
  title: string;
  description: string;
  fields: Array<{ label: string; value?: string | number }>;
}) => (
  <section className="flex h-full min-h-0 flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
    <header className="shrink-0 border-b border-slate-200 bg-white px-5 py-4">
      <h2 className="text-base font-semibold text-slate-950">{title}</h2>
      <p className="mt-1 text-sm font-medium text-slate-500">{description}</p>
    </header>
    <div className="min-h-0 flex-1 p-5">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {fields.map((field) => (
          <InfoField
            key={field.label}
            label={field.label}
            value={fieldValue(field.value)}
          />
        ))}
      </div>
    </div>
  </section>
);
